import axios from "axios";
import { IBookingsApiFilter } from "../types";


export interface IGetBookingsSummaryParams {
    filters?: IBookingsApiFilter,
    showInfo?: boolean,
}

export interface IGetBookingsSummaryReturn {
    summary: {
        total: number,
        pending: number,
        rejected: number,
        offers: number,
        confirmed: number,
        assigned: number,
        cancelled: number,
        fulfilled: number,
        fail: number,
        draft: number,
        totalDays: number,
        pendingDays: number,
        rejectedDays: number,
        offersDays: number,
        confirmedDays: number,
        assignedDays: number,
        cancelledDays: number,
        fulfilledDays: number,
        failDays: number,
        draftDays: number,
    }
}

export const getBookingsSummary = async (params: IGetBookingsSummaryParams): Promise<IGetBookingsSummaryReturn> => {
    const response = await axios.post('/booking/search/summary', params);
    return response.data;
};
